import { NameValuePair } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { theme } from '@features/executive-report/domain/theme';
import { TextProps } from '@features/powerpoint';

const topAudienceValueTextOptions = [
  {
    fontSize: 48,
    h: 0.81,
    w: 3.37,
    x: 0.83,
    y: 2.08,
  },
  {
    fontSize: 36,
    h: 0.71,
    w: 2.66,
    x: 4.75,
    y: 2.35,
  },
  {
    fontSize: 32,
    h: 0.64,
    w: 2.91,
    x: 1.3,
    y: 4.5,
  },
  {
    fontSize: 26,
    h: 0.54,
    w: 2.37,
    x: 4.79,
    y: 4.45,
  },
] as const satisfies readonly TextProps['options'][];

export const topAudienceToTextProps = (
  nameValuePair: NameValuePair,
  audienceIndex: number
): TextProps[] => {
  const defaultTextOptions =
    topAudienceValueTextOptions[audienceIndex] ??
    topAudienceValueTextOptions[0];
  return [
    {
      text: nameValuePair.value.toString(),
      options: {
        ...defaultTextOptions,
        color: theme.colors.white,
        align: 'center',
        x: defaultTextOptions.x,
      },
    },
    {
      text: nameValuePair.name,
      options: {
        ...defaultTextOptions,
        fontSize: 10,
        color:
          audienceIndex < 2
            ? theme.colors.inmarketGreen
            : theme.colors.lightGray,
        align: 'center',
        valign: 'top',
        h: 0.37,
        x: defaultTextOptions.x,
        y: defaultTextOptions.y + defaultTextOptions.h * 1,
      },
    },
  ];
};
